// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"6495d2e1","132":"14e595dc","147":"f6420b84","241":"1a1b42a3","320":"5ed75e78","376":"40df2ba0","416":"89485067","566":"8034e5cb","579":"b49b95b2","590":"c2c6c8f5"}[chunkId] + ".chunk.js";
};